var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',{staticClass:"bg"},[_c('el-aside',{staticClass:"left_bg"},[_c('leftMenuDiv',{ref:"leftMenuDiv"})],1),_c('el-main',{staticClass:"content-box"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }